import * as React from 'react';
import { cn } from '../lib/cn';
import { dateTime } from '../lib/format';

// The one table for every screen (prototype tables): header row in tick-ink uppercase (styles.css `thead th`), 12×16
// cell padding, thin row dividers, a white card around it. Change the table design here and in styles.css (.ps-table)
// only. `bare` drops the card when the table already sits inside one; `compact` is the history "Compact view".
export function Table({ children, label, bare = false, compact = false, className, tableClassName }: {
  children: React.ReactNode; label?: string; bare?: boolean; compact?: boolean; className?: string; tableClassName?: string;
}) {
  return (
    <div className={cn('overflow-x-auto', !bare && 'rounded-card border border-line bg-surface shadow-card', className)}>
      <table aria-label={label} data-density={compact ? 'compact' : undefined} className={cn('ps-table', tableClassName)}>{children}</table>
    </div>
  );
}

/** A clickable row (pointer and hover tint); keep a real button or link inside it for keyboard users. Without `onOpen`
 * (a row with nothing to open) it is a plain row. Other buttons in the row use `stop` so they don't open it too. */
export function LinkRow({ onOpen, className, children, ...p }: React.HTMLAttributes<HTMLTableRowElement> & { onOpen?: (() => void) | null }) {
  return onOpen ? <tr data-link="" className={className} onClick={onOpen} {...p}>{children}</tr> : <tr className={className} {...p}>{children}</tr>;
}
/** Wraps a click handler inside a LinkRow so it doesn't also open the row. */
export const stop = (fn: () => void) => (e: React.MouseEvent) => { e.stopPropagation(); fn(); };

/** A group header row spanning the table. */
export function GroupRow({ colSpan, children }: { colSpan: number; children: React.ReactNode }) {
  return <tr data-group=""><td colSpan={colSpan}>{children}</td></tr>;
}

/** Date on the first line, time below in small grey (prototype tables: "05 Sep 2026 / 11:04 HKT"). */
export function DateCell({ iso, oneLine = false }: { iso: string; oneLine?: boolean }) {
  const [d, t] = dateTime(iso).split(' · ');
  return oneLine ? <>{d} · {t}</> : <>{d}<span className="block text-xs text-ink-3">{t}</span></>;
}
